import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useTheme } from "@/contexts/ThemeContext";
import { useState } from "react";
import { toast } from "sonner";

export default function Settings() {
  const { theme, toggle } = useTheme();
  const [emailNotif, setEmailNotif] = useState(true);
  const [smsNotif, setSmsNotif] = useState(false);
  const [wa, setWa] = useState(true);

  return (
    <DashboardLayout>
      <div className="space-y-6 max-w-3xl">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Settings</div>
          <h1 className="font-display text-3xl mt-2">Preferences</h1>
        </div>
        <Card className="p-6 space-y-6">
          <div className="flex items-center justify-between">
            <div><Label>Dark mode</Label><div className="text-xs text-muted-foreground">Reduce eye strain in low light</div></div>
            <Switch checked={theme === "dark"} onCheckedChange={toggle} data-testid="settings-dark" />
          </div>
          <div className="flex items-center justify-between">
            <div><Label>Email notifications</Label><div className="text-xs text-muted-foreground">Approvals, EMI reminders, statements</div></div>
            <Switch checked={emailNotif} onCheckedChange={(v) => { setEmailNotif(v); toast.success("Preferences saved"); }} />
          </div>
          <div className="flex items-center justify-between">
            <div><Label>SMS notifications</Label><div className="text-xs text-muted-foreground">One-time codes and critical alerts</div></div>
            <Switch checked={smsNotif} onCheckedChange={(v) => { setSmsNotif(v); toast.success("Preferences saved"); }} />
          </div>
          <div className="flex items-center justify-between">
            <div><Label>WhatsApp updates</Label><div className="text-xs text-muted-foreground">Optional loan-related updates on WhatsApp</div></div>
            <Switch checked={wa} onCheckedChange={(v) => { setWa(v); toast.success("Preferences saved"); }} />
          </div>
        </Card>
      </div>
    </DashboardLayout>
  );
}
